module.exports = __webpack_public_path__ + "img/u1013.2c4bda3f.svg";